import { render, staticRenderFns } from "./AllegatoList.vue?vue&type=template&id=4501b18a&"
import script from "./AllegatoList.vue?vue&type=script&lang=js&"
export * from "./AllegatoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports